// extracted by mini-css-extract-plugin
export var chevronIcon = "_4z-2";
export var teamName = "_4z-1";
export var teamSwitcherButton = "_4z-0";